import { AngularMaterialLibsModule } from './../../shared/angular-material-libs.module';
import { NgModule } from '@angular/core';
import { MainLayoutRoutingModule } from './main-layout-routing.module';
import { MainLayoutComponent } from './main-layout.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { SharedModule as AppSharedModule } from './../../shared/shared.module';

@NgModule({
  declarations: [
    MainLayoutComponent,
    BreadcrumbComponent,
    FooterComponent,
    HeaderComponent,
    NavBarComponent,
  ],
  imports: [
    AngularMaterialLibsModule,
    MainLayoutRoutingModule,
    AppSharedModule,
  ],
})
export class MainLayoutModule {}
